import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import cookie from "discourse/lib/cookie";
import Category from "discourse/models/category";
import DiscourseRoute from "discourse/routes/discourse";
let _class = (_class2 = class _class2 extends DiscourseRoute {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "composer", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "currentUser", _descriptor3, this);
    _initializerDefineProperty(this, "site", _descriptor4, this);
  }
  async beforeModel(transition) {
    if (this.currentUser) {
      let category;
      if (this.site.lazy_load_categories) {
        if (transition.to.queryParams.category_id) {
          const categories = await Category.asyncFindByIds([transition.to.queryParams.category_id]);
          category = categories[0];
        } else if (transition.to.queryParams.category) {
          category = await Category.asyncFindBySlugPath(transition.to.queryParams.category);
        }
      } else {
        category = this.parseCategoryFromTransition(transition);
      }
      if (category) {
        // Using URL-based transition to avoid bug with dynamic segments and refreshModel query params
        // https://github.com/emberjs/ember.js/issues/16992
        this.router.replaceWith(`/c/${category.id}`).followRedirects().then(() => {
          if (this.currentUser.can_create_topic) {
            this.openComposer({
              transition,
              category
            });
          }
        });
      } else if (transition.from) {
        // Navigation from another ember route
        transition.abort();
        this.openComposer({
          transition
        });
      } else {
        this.router.replaceWith("discovery.latest").followRedirects().then(() => {
          if (this.currentUser.can_create_topic) {
            this.openComposer({
              transition
            });
          }
        });
      }
    } else {
      // User is not logged in
      cookie("destination_url", window.location.href);
      this.router.replaceWith("login");
    }
  }
  openComposer(_ref) {
    let {
      transition,
      category
    } = _ref;
    next(() => {
      this.composer.openNewTopic({
        title: transition.to.queryParams.title,
        body: transition.to.queryParams.body,
        category,
        tags: transition.to.queryParams.tags
      });
      this.composer.set("formTemplateInitialValues", transition.to.queryParams);
    });
  }
  parseCategoryFromTransition(transition) {
    let category;
    if (transition.to.queryParams.category_id) {
      const categoryId = transition.to.queryParams.category_id;
      category = Category.findById(categoryId);
    } else if (transition.to.queryParams.category) {
      const splitCategory = transition.to.queryParams.category.split("/");
      category = this._getCategory(splitCategory[0], splitCategory[1], "nameLower");
      if (!category) {
        category = this._getCategory(splitCategory[0], splitCategory[1], "slug");
      }
    }
    return category;
  }
  _getCategory(mainCategory, subCategory, type) {
    let category;
    if (!subCategory) {
      category = this.site.categories.findBy(type, mainCategory.toLowerCase());
    } else {
      const categories = this.site.categories;
      const main = categories.findBy(type, mainCategory.toLowerCase());
      if (main) {
        category = categories.find(item => {
          return item && item[type] === subCategory.toLowerCase() && item.parent_category_id === main.id;
        });
      }
    }
    return category;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "composer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2);
export { _class as default };